module.exports = "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwODAgMTAwMCI+CiAgICA8cGF0aCBkPSJNNjc1LjIgMjQ1LjU5TDM2MSAxMDAwSDE0OS42M2w4Ny45MS0xOTguNDNMMCAyNDUuNTloMjE1LjA5bDEyMy40NSAzMTguMjQgMTI3LjE4LTMxOC4yNHpNODQ4Ljg4IDBMNjQwLjM5IDUwMC41NmgyMzEuMTJMMTA4MCAwem0tMTEwLjQgMjg2LjcybC0zOC43NSAyNjIuNjZBMTI5LjE4IDEyOS4xOCAwIDEwODI4LjggNjc4LjU2YTEyOS4xMiAxMjkuMTIgMCAwMC0xMjkuMDctMTI5LjE4eiIgZmlsbD0iIzVmMDFkMSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/components/ReminderModal/images/yahoo-calendar-icon.svg
// module id = ./src/components/ReminderModal/images/yahoo-calendar-icon.svg
// module chunks = 5